<div class="ot-header-bar-message-container ot-collapsed" [ngClass]="messageClass">
    <div class="ot-message-header-content-container">
        <img class='ot-message-icon' *ngIf="hbi.showIcon" [src]="hbi.messageIcon">
        <div class='ot-message-text' [title]="hbi.message">{{hbi.message}}</div>
        <img class='ot-message-close' *ngIf="hbi.showClose" (click)="onClose()"
            src="assets/images/dismiss_notification24.svg">
    </div>
</div>